<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ $t('Gestionar cantidades por defecto para las cajas') }}
      </p>
      <button type="button" class="delete ml-4" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-table :data="categories">
        <b-table-column
          field="title"
          :label="$t('Categoría')"
          sortable
          v-slot="props"
        >
          {{ props.row.title }}
        </b-table-column>

        <b-table-column v-slot="props">
          <b-button
            class="is-small"
            icon-left="pen"
            @click="editCategory(props.row)"
          ></b-button>
          <b-button
            class="is-small"
            icon-left="trash-alt"
            @click="deleteCategory(props.row)"
          ></b-button>
        </b-table-column>
      </b-table>
    </section>
    <footer class="modal-card-foot">
      <!-- <b-button :label="$t('Cerrar')" @click="$emit('close')" /> -->
      <b-field :label="$t('Crear nueva cantidad')">
        <b-input
          v-model="categoryName"
          :placeholder="$t('Nombre')"
          type="number"
          min="0"
        >
        </b-input>
        <b-button
          v-if="is_editing"
          label="Modificar"
          type="is-primary"
          @click="updateData()"
        />
        <b-button
          v-else
          :label="$t('Crear')"
          type="is-primary"
          @click="sendData()"
        />
      </b-field>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      is_editing: false,
      categoryName: null,
      categoryNid: null,
      categoryToModify: null,
      categories: []
    }
  },
  computed: {
    ...mapState('club', ['currentClub'])
  },
  methods: {
    deleteCategory(category) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.$store
        .dispatch('club/deleteCategory', {
          asocid: this.currentClub.nid,
          category: category
        })
        .then(() => {
          loadingComponent.close()
          this.categories.splice(this.categories.indexOf(category), 1)
        })
    },
    editCategory(category) {
      this.categoryToModify = category
      this.categoryName = category.title
      this.categoryNid = category.nid
      this.is_editing = true
    },
    updateData() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      let newcategory = {
        association: this.currentClub.nid,
        type: 'cash-register',
        title: this.categoryName,
        nid: this.categoryNid
      }
      var index = this.categories.indexOf(this.categoryToModify)
      if (index !== -1) {
        this.categories[index].title = newcategory.title
        this.categories[index].descuento = newcategory.descuento
      }

      this.$store
        .dispatch('club/updateCategory', {
          category: this.categoryToModify,
          newcategory: newcategory
        })
        .then(() => {
          loadingComponent.close()
          this.is_editing = false
          this.categoryName = null

          //   this.$emit('close')
        })
    },
    sendData() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      let json = {
        association: this.currentClub.nid,
        type: 'cash-register',
        title: this.categoryName
      }
      this.$store.dispatch('club/createCategory', json).then(response => {
        loadingComponent.close()
        this.categoryName = null
        json.nid = response.data.nid
        this.categories.push(json)
      })
    }
  },
  created() {
    this.$store
      .dispatch('club/fetchCategories', {
        asocid: this.currentClub.nid,
        type: 'cash-register'
      })
      .then(response => {
        this.categories = response.data
      })
  }
}
</script>

<style lang="scss" scoped></style>
